import { render, staticRenderFns } from "./MediaAdmin.vue?vue&type=template&id=33304303&scoped=true&lang=pug"
import script from "./MediaAdmin.vue?vue&type=script&lang=js"
export * from "./MediaAdmin.vue?vue&type=script&lang=js"
import style0 from "./MediaAdmin.vue?vue&type=style&index=0&id=33304303&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33304303",
  null
  
)

export default component.exports